import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import FilteredTournamentsList from './FilteredTournamentsList';
import { api } from '../../AppConfig';


function Tournaments() {
  // Access the client
  const queryClient = useQueryClient();

  // console.warn('che id mi viene passato?', id);
  // setting the from date to 5 days before today
    const today = new Date();
    const fromDate = new Date(today);
    fromDate.setDate(fromDate.getDate() - 5);
    // setting the to date to 2 months after today
    const toDate = new Date(today);
    toDate.setMonth(toDate.getMonth() + 2);
    // settting the to date to 23 days after today (to include the tournaments of the current month)
    const toDateShort = new Date(today);
    toDateShort.setDate(toDateShort.getDate() + 23);
    // converting the date to the format YYYY-MM-DD
    const fromDateString = fromDate.toISOString().split('T')[0];
    const toDateString = toDate.toISOString().split('T')[0];
    const toDateShortString = toDateShort.toISOString().split('T')[0];
    // console.warn('fetching tournaments from', fromDateString, 'to', toDateString);

  //otherwise we fetch the data and pass to the display component
  const lpiTournamentsQuery = useQuery({ 
    queryKey: ['filteredTournaments'], 
    queryFn: () => 
      fetch(api.tournaments().filteredList([4,5,6,7,9,10,11,13], fromDateString, toDateShortString, 'asc').href).then((res) =>
        res.json(), 
      )
  })

  const lpiUnofficialTournamentsQuery = useQuery({ 
    queryKey: ['filteredUnofficialTournaments'], 
    queryFn: () => 
      fetch(api.tournaments().filteredList([12], '', '', 'asc').href).then((res) =>
        res.json(), 
      )
  })

  return <FilteredTournamentsList 
            pending={lpiTournamentsQuery.isPending || lpiUnofficialTournamentsQuery.isPending} 
            tournaments={lpiTournamentsQuery.data} 
            unofficialTournaments={lpiUnofficialTournamentsQuery.data}
  />;
}

export default Tournaments;